module.exports = __webpack_public_path__ + "static/gallery_01-fe0667c621766b289583a7e70244915e.jpg";